module.exports = __webpack_public_path__ + "static/img/yjjy.87eb3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/yjjy.png
// module id = s6+b
// module chunks = 64